<template>
  <div class="container-page">
    <app-list
      :total-entries="length"
      :entries="terms"
      :headers="headers"
      :pagination="pagination"
      :is-render="isRender"
      :loading-list="loading"
      :has-search="false"
      :has-filter="false"
      :has-chart="false"
      @paginate="paginate">
      <template v-slot:row="row">
        <row :props="row.props" />
      </template>
    </app-list>
  </div>
</template>

<script>
  import AppList from '@/components/ui/List'
  import Row from './Row'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      AppList,
      Row
    },
    data () {
      return {
        messageModal: '',
        showModal: false,
        headers: [
          { text: 'Caso', value: 'code', sortable: false },
          { text: 'Origem', value: 'origin', align: 'center', sortable: false },
          { text: 'Motivo', value: 'status', align: 'center', sortable: false },
          { text: 'Ocorrido em', value: 'event', align: 'center', sortable: false },
          { text: 'Criado em', value: 'insertedAt', align: 'center', sortable: false },
          { text: 'Termo', value: 'file', align: 'center', sortable: false }
        ],
        pagination: {
          page: parseInt(sessionStorage.getItem('TemsDroppedPaginationPage') || 1),
          rowsPerPage: parseInt(sessionStorage.getItem('TemsDroppedPaginationRowsPerPage') || 12),
          rowsPerPageItems: [12, 25, 50, 100]
        },
        series: [],
        rowSelected: {}
      }
    },
    computed: {
      ...mapGetters({
        length: 'termsDropped/length',
        terms: 'termsDropped/list',
        loading: 'termsDropped/listLoading',
        isRender: 'termsDropped/listRender'
      })
    },
    watch: {
      pagination: {
        handler (pagination) {
          sessionStorage.setItem('TemsDroppedPaginationRowsPerPage', pagination.rowsPerPage)
          this.$store.dispatch('termsDropped/getList', pagination)
        },
        deep: true
      },
      deep: true
    },
    beforeMount () {
      this.$store.dispatch('termsDropped/getList', this.pagination)
    },
    methods: {
      paginate (paginate) {
        this.pagination = paginate
      }
    }
  }
</script>
